import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Profile from "../pages/Profile";
import Top from "../pages/Top";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Top />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
